module.exports = __webpack_public_path__ + "static/media/torno2.f1ead30d.png";